import { formatPercentageTwoDp } from "@/utils/numberFormattingUtils";

export const DevicesPercentageListTooltipContent = ({
  label,
  value,
  plays
}: {
  label: string;
  value: number;
  plays: number;
}) => {
  return (
    <div>
      <p className="mb-2 text-sm font-medium ">{label}</p>
      <p className="text-md font-medium text-[#4040A8]">{formatPercentageTwoDp(value)}%</p>
      <p className="flex flex-col text-sm">
        <span className="text-textMedGrey mb-2">
          of your total podcast downloads happen on <strong>{label}</strong>. That is a total of:
        </span>
      </p>
      <p className="text-md font-medium text-[#4040A8]">{plays.toLocaleString()}</p>
      <p className="flex flex-col text-sm">
        <span className="text-sm text-textMedGrey ">
          downloads
        </span>
      </p>
      <p className="text-xs text-textMedGrey mt-2">
        Please note this figure only accounts for podcast content hosted by Acast.
      </p>
    </div>
  );
};
